import { STORAGE, API_ENDPOINT } from "../../constants";
import { HTTP } from "../http";
import { StorageService } from "../storage";

export const PartnerAccountsService = {
  save: (data: {
    period: string;
    partner: string;
    date: string;
    type: string;
    amount: number;
    comments: string;
  }) => {
    const { account } = StorageService.get(STORAGE.USER);
    return HTTP.post<any, any>(`${API_ENDPOINT}operation/partner-accounts`, {
      ...data,
      account,
    });
  },
  list: (period: string) => {
    const { account } = StorageService.get(STORAGE.USER);
    return HTTP.get<any, any>(`${API_ENDPOINT}operation/partner-accounts/${account}/${period}`);
  },
};
